import { Pagination } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { checkTagValidity } from "../../Utils/Utils";
import {
  ADD_POINT_SERVICE,
  CHARGER_POINT_SERVICE_PAR_LOT,
  DELETE_POINT_SERVICE,
  LIST_POINT_SERVICE,
} from "../../Utils/constant";
import modelFicherPS from "../../assets/model-fichier/modelPS.xlsx";
import { Home } from "../../components/Icons/Home";
import { Loader } from "../../components/Widget/Loader";
import { UploadButton } from "../../components/Widget/UploadButton";
import { deleteOne, store } from "../../services/service";
import { useStorePointService } from "../../store/Paramettre/pointServiceStore";

const typeLabel = (type) =>
  type
    ?.replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase()) ?? "";

export const PointService = () => {
  const pointServices = useStorePointService();
  const [selectItem, setSelectItem] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectType, setSelectType] = useState(null);

  const openAdd = (item = null) => {
    setSelectItem(item);
    setSelectType(item?.typeP ?? null);
    reset(
      item
        ? {
            designation: item.designation,
            typePointService: item.typeP,
            description: item.description,
          }
        : {},
    );
    document.getElementById("add").showModal();
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(
      ADD_POINT_SERVICE,
      "application/json",
      selectItem ? { ...data, id: selectItem.id } : data,
    )
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("add").close();
          toast.success(
            selectItem ? "Point service modifié" : "Point service ajouté",
          );
          pointServices.getData(
            `${LIST_POINT_SERVICE}?type=&page=0&param=&size=8`,
          );
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  useEffect(() => {
    pointServices.getData(`${LIST_POINT_SERVICE}?type=&page=0&param=&size=8`);
  }, []);

  const more = (page) => {
    pointServices.getData(
      `${LIST_POINT_SERVICE}?type=&page=${page - 1}&param=&size=8`,
    );
  };

  const inputCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";
  const selectCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";
  const closeBtnCls =
    "w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition";

  return (
    <>
      {/* Header */}
      <div className="mt-4 mb-1">
        <p className="text-2xl font-bold text-gray-900 tracking-tight">
          Points de service
        </p>
        <p className="text-sm text-gray-400 mt-1">
          Gestion des points connect et service centers
        </p>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 py-4 border-b border-gray-100 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 h-10">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            onChange={(e) =>
              pointServices.getData(
                `${LIST_POINT_SERVICE}?type=&page=0&param=${e.target.value}&size=8`,
              )
            }
            type="text"
            placeholder="Rechercher un point service…"
            className="bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 w-52"
          />
        </div>

        <div className="ml-auto flex items-center gap-2">
          <UploadButton
            uploadUrl={CHARGER_POINT_SERVICE_PAR_LOT}
            fetchData={() =>
              pointServices.getData(
                `${LIST_POINT_SERVICE}?type=&page=0&param=&size=8`,
              )
            }
            model={modelFicherPS}
          />
          {checkTagValidity("AJOUTER_POINT_SERVICE") && (
            <button
              onClick={() => openAdd()}
              className="h-10 px-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-sm font-semibold rounded-lg transition"
            >
              Ajouter
            </button>
          )}
        </div>
      </div>

      {/* Add / Edit Modal */}
      <dialog id="add" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              {selectItem
                ? "Modifier le point service"
                : "Nouveau point service"}
            </h2>
            <form method="dialog">
              <button id="fermer_create_trajet" className={closeBtnCls}>
                ✕
              </button>
            </form>
          </div>

          <form onSubmit={handleSubmit(submit)} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Désignation <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                defaultValue={selectItem?.designation}
                {...register("designation", { required: true })}
              />
              {errors.designation && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Type de point service <span className="text-red-500">*</span>
              </label>
              <select
                value={selectType ?? ""}
                {...register("typePointService", { required: true })}
                onChange={(e) => setSelectType(e.target.value)}
                className={selectCls}
              >
                <option value="">Sélectionner un type</option>
                <option value="POINT_CONNECT">Point connect</option>
                <option value="SERVICE_CENTER">Service center</option>
              </select>
              {errors.typePointService && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Description
              </label>
              <textarea
                {...register("description")}
                defaultValue={selectItem?.description}
                rows={3}
                placeholder="Description du point service…"
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition resize-none"
              />
            </div>

            <button
              type="submit"
              disabled={isSubmit}
              className={`w-full h-10 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
                isSubmit
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
              }`}
            >
              {isSubmit ? (
                <>
                  <span className="loading loading-spinner loading-xs" />{" "}
                  Enregistrement…
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
          </form>
        </div>
      </dialog>

      {/* Delete Modal */}
      <dialog id="delete" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <p className="text-base font-bold text-gray-900 mb-1">
            Confirmer la suppression
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Le point service{" "}
            <span className="font-semibold text-gray-800">
              {selectItem?.designation}
            </span>{" "}
            sera définitivement supprimé.
          </p>
          <div className="flex justify-end gap-2">
            <form method="dialog">
              <button className="h-9 px-4 rounded-lg text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
                Annuler
              </button>
            </form>
            <form method="dialog">
              <button
                onClick={() => {
                  deleteOne(DELETE_POINT_SERVICE, selectItem.id)
                    .then(() => {
                      pointServices.getData(
                        `${LIST_POINT_SERVICE}?type=&page=0&param=&size=8`,
                      );
                      toast.success(`${selectItem.designation} supprimé`);
                    })
                    .catch(() => {});
                }}
                className="h-9 px-4 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition"
              >
                Supprimer
              </button>
            </form>
          </div>
        </div>
      </dialog>

      {/* Grid */}
      {pointServices?.loading ? (
        <Loader />
      ) : pointServices?.data?.data?.length === 0 ? (
        <div className="flex items-center justify-center h-48">
          <p className="text-sm text-gray-400">Aucun point service trouvé</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
          {pointServices?.data?.data?.map((item) => (
            <div
              key={item.id}
              className="relative bg-white border border-gray-200 rounded-xl p-3 flex items-start gap-3 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
            >
              {/* Menu */}
              <div className="dropdown dropdown-end absolute top-2 right-2">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500 transition cursor-pointer"
                >
                  <MoreHorizontal size={15} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content z-10 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-40 p-1.5"
                >
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                      onClick={() => openAdd(item)}
                    >
                      Modifier
                    </button>
                  </li>
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-red-600 rounded-lg hover:bg-red-50 transition"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("delete").showModal();
                      }}
                    >
                      Supprimer
                    </button>
                  </li>
                </ul>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center shrink-0 text-gray-500">
                <Home />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 pt-0.5 pr-6">
                <p className="text-xs font-semibold text-gray-900 truncate">
                  {item?.designation}
                </p>
                {item?.typeP && (
                  <span className="inline-block mt-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-full px-2 py-0.5">
                    {typeLabel(item.typeP)}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-end mt-6">
        <Pagination
          onChange={(_, v) => more(v)}
          count={pointServices?.data?.totalPages}
          variant="outlined"
          color="primary"
          shape="rounded"
          size="small"
        />
      </div>
    </>
  );
};
